import { useEffect, useRef } from "react";

const fotos = [
  { alt: "Visão, Missão e Valores da Ferrarezi no evento RH do Futuro", src: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/edaa664a-c879-49b3-93cc-d4e7f2bb676d_compressed_IMG_8431.webp" },
  { alt: "Humanização é o produto principal do RH — palestra Ferrarezi", src: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/3a09326b-9069-4644-87de-e1954695d9ab_compressed_IMG_8438.webp" },
  { alt: "Marcella Ferrarezi no palco do evento RH do Futuro", src: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/660043fa-fc2a-4fe6-bb3d-538b75f9db1f_compressed_IMG_8354.webp" },
  { alt: "Do RH operacional ao RH visionário — apresentação Ferrarezi", src: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/5021f453-3f76-4508-b4ae-65c05f8e1cb0_compressed_IMG_8388.webp" },
  { alt: "Certificados de participação do evento RH do Futuro", src: "https://storage.readdy-site.link/project_files/9309375e-f328-4fba-b8d7-64d73f28a855/c13c0bac-4cd8-492a-af88-2d48c3109648_compressed_WhatsApp-Image-2026-05-21-at-16.22.55-2.webp" },
];

const allFotos = [...fotos, ...fotos, ...fotos];

export default function Eventos() {
  const trackRef = useRef<HTMLDivElement>(null);
  const animRef = useRef<number>(0);
  const posRef = useRef<number>(0);
  const pausedRef = useRef<boolean>(false);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const speed = 0.6;

    const animate = () => {
      if (!pausedRef.current) {
        posRef.current += speed;
        const totalWidth = track.scrollWidth / 3;
        if (posRef.current >= totalWidth) {
          posRef.current = 0;
        }
        track.style.transform = `translateX(-${posRef.current}px)`;
      }
      animRef.current = requestAnimationFrame(animate);
    };

    animRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animRef.current);
  }, []);

  return (
    <section id="eventos" className="py-16 relative bg-[#0D0D0D]">
      {/* Título */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-10 text-center">
        <div className="inline-flex items-center gap-3">
          <span className="w-6 h-px bg-[#FBC52D]" />
          <p className="text-xs font-semibold tracking-widest uppercase text-[#FBC52D]">
            Eventos e Experiências
          </p>
          <span className="w-6 h-px bg-[#FBC52D]" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-white mt-5 leading-tight">
          Momentos que Transformam
        </h2>
        <p className="text-gray-400 text-base mt-3 max-w-xl mx-auto">
          Palestras, imersões e encontros que transformam a gestão de pessoas e aceleram resultados.
        </p>
      </div>

      {/* Carrossel */}
      <div className="relative overflow-hidden">
        {/* Degrade esquerda */}
        <div
          className="absolute left-0 top-0 h-full w-20 md:w-32 z-10 pointer-events-none"
          style={{ background: "linear-gradient(to right, #0D0D0D 0%, transparent 100%)" }}
        />
        {/* Degrade direita */}
        <div
          className="absolute right-0 top-0 h-full w-20 md:w-32 z-10 pointer-events-none"
          style={{ background: "linear-gradient(to left, #0D0D0D 0%, transparent 100%)" }}
        />

        <div
          ref={trackRef}
          className="flex items-center gap-4 will-change-transform"
          style={{ width: "max-content" }}
          onMouseEnter={() => { pausedRef.current = true; }}
          onMouseLeave={() => { pausedRef.current = false; }}
        >
          {allFotos.map((foto, idx) => (
            <div
              key={`${foto.alt}-${idx}`}
              className="flex-shrink-0 group cursor-default rounded-xl overflow-hidden border border-white/10 hover:border-[#FBC52D]/40 transition-all duration-300"
              style={{ width: 320, height: 220 }}
            >
              <img
                src={foto.src}
                alt={foto.alt}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-10 text-center">
        <button
          onClick={() => document.querySelector("#contato")?.scrollIntoView({ behavior: "smooth" })}
          className="whitespace-nowrap bg-[#FBC52D] text-black font-semibold px-7 py-3 rounded-full hover:bg-[#d4a800] transition-colors text-sm cursor-pointer"
        >
          Quero participar do próximo evento
        </button>
      </div>
    </section>
  );
}